import { render } from "./pageTable.vue?vue&type=template&id=70c9c61c&scoped=true"
import script from "./pageTable.vue?vue&type=script&lang=js"
export * from "./pageTable.vue?vue&type=script&lang=js"

import "./pageTable.vue?vue&type=style&index=0&id=70c9c61c&lang=scss&scoped=true"

import exportComponent from "/Volumes/kaifa/ApiJavaAdmin/vn-admin-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70c9c61c"]])

export default __exports__